import createReactComponent from '../createReactComponent';
export default createReactComponent('alert-small-off', 'IconAlertSmallOff', [
  ['path', { d: 'M12 16h.01', key: 'svg-0' }],
  ['path', { d: 'M12 7v1', key: 'svg-1' }],
  ['path', { d: 'M3 3l18 18', key: 'svg-2' }],
]);
